import { NameInput } from 'sr-types/lib/production/v1/graphql';

/**
 * Splits a name typed or picked as one string into the `NameInput` the services expect.
 *
 * The first word is the first name and the rest is the last name. A single-word name has no
 * last name to give, so it takes `defaultLastName` - callers that save a person pass
 * `DEFAULT_PERSON_LAST_NAME`, the placeholder the person editor shows.
 *
 * Kept in its own module because it is needed by contact conversions that have no business
 * loading `peopleUtils` - which reaches the data grid, the toasts and the theme behind it.
 * `peopleUtils` re-exports it for the callers that always had it there.
 */
export function extractNames(query: string, defaultLastName: string = ''): NameInput {
    const [firstName, ...lastName] = query.toString().split(' ');

    const prePopulateName: NameInput = {
        firstName: firstName || '',
        lastName: lastName.length > 0 ? lastName.join(' ') : defaultLastName
    };

    return prePopulateName;
}
